import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
// import LanguageDetector from 'i18next-browser-languagedetector' // Disabled - Hebrew only

// Import translation files
import he from './locales/he.json'
// import en from './locales/en.json' // Disabled - Hebrew only
// import it from './locales/it.json' // Disabled - Hebrew only

const resources = {
  he: {
    translation: he,
  },
  // Disabled other languages - Hebrew only
  // en: {
  //   translation: en,
  // },
  // it: {
  //   translation: it,
  // },
}

i18n
  // .use(LanguageDetector) // Disabled - Hebrew only
  .use(initReactI18next)
  .init({
    resources,
    lng: 'he', // Hebrew only
    fallbackLng: 'he', // Hebrew only
    debug: import.meta.env.DEV,
    
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    
    // Disabled language detection - Hebrew only
    // detection: {
    //   order: ['localStorage', 'navigator', 'htmlTag'],
    //   caches: ['localStorage'],
    // },
  })

export default i18n
